export const baseUrl = "https://feynman-8wtmz.ondigitalocean.app";

// export const baseUrl = "https://prodapi.glosity.club";
